import { useNavigate } from 'react-router'
import { Text } from '../../components/Text'
import { TextButton } from '../../components/TextButton'
import { ApplicationStatusCard } from '../application-status/ApplicationStatusCard'
import { useApplicationStatusCard } from '../application-status/useApplicationStatusCard'

function ApplicationStatusHeading({ onViewAll }: { onViewAll: () => void }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <Text as="h2" variant="h3" weight="bold" className="text-gray-700">
        Application Status
      </Text>
      <TextButton onClick={onViewAll}>
        View All
      </TextButton>
    </div>
  )
}

export function ApplicationStatusSection() {
  const navigate = useNavigate()
  const cardProps = useApplicationStatusCard()

  return (
    <section className="flex flex-col gap-3">
      <ApplicationStatusHeading onViewAll={() => navigate('/application-status')} />
      <ApplicationStatusCard {...cardProps} />
    </section>
  )
}
